module.exports = __webpack_public_path__ + "static/story4-social-1200x630-614072c617b6737202b271bdc51a2c45.jpg";